<template>
  <index-view-layout
    data-name="Item"
    :side-drawer-component="sideDrawerComponent"
    @search="searchItems"
    searchable
  >
    <div class="flex flex-col justify-between w-full" v-if="displayedItems">
      <template v-if="$mq === 'sm'">
        <item-cell
          class="block md:hidden"
          v-for="(item, index) in displayedItems"
          :key="`${item.name}-${index}`"
          :item="item"
        />
      </template>
      <bdg-table-view
        :rows="displayedItems"
        :columns="columns"
        :page-options="{
          isPaged: displayedItems.length > 10,
          itemsPerPage: 10
        }"
        empty-state-text="No items to view."
        :loading="isLoading"
        v-else
      >
      </bdg-table-view>
    </div>
  </index-view-layout>
</template>

<script>
import BdgTableView from "../../elements/table-view/BdgTableView";
import ItemCell from "../../elements/list-view/list-view-cells/ItemCell";
import IndexViewLayout from "../layouts/IndexViewLayout";
import ItemForm from "./ItemForm";
import GenericDeleteModal from "../../components/modals/GenericDeleteModal";

export default {
  name: "Items",
  components: {
    IndexViewLayout,
    ItemCell,
    BdgTableView
  },
  data() {
    return {
      columns: [
        { label: "item name", property: "name" },
        { label: "vendor", property: "vendorNameWithCompany" },
        {
          label: "actions",
          property: "actions",
          actions: [
            {
              label: "edit",
              clickAction: item => {
                this.$store.commit("setCreateEditComponentParams", {
                  createEditComponent: ItemForm,
                  createEditComponentData: item,
                  createEditComponentIsShown: true
                });
              }
            },
            {
              label: "delete",
              clickAction: item => {
                this.$store.commit("setConfirmationModalParams", {
                  type: "delete",
                  headerText: "Delete Confirmation",
                  bodyComponent: GenericDeleteModal,
                  bodyComponentData: {
                    entityName: "item",
                    deleteFunction: () =>
                      this.$store.dispatch("deleteItem", item)
                  },
                  isShown: true
                });
              }
            }
          ],
          additionalCellClasses: "w-px whitespace-no-wrap"
        }
      ],
      sideDrawerComponent: ItemForm
    };
  },
  computed: {
    showSearchResults() {
      return this.$store.state.Search.areSearchResultsShown;
    },
    isGettingItems() {
      return this.$store.state.Items.isGettingItems;
    },
    isSearchingItems() {
      return this.$store.state.Search.isSearchingItems;
    },
    isLoading() {
      return this.showSearchResults
        ? this.isSearchingItems
        : this.isGettingItems;
    },
    items() {
      const items = this.$store.state.Items.items;
      if (items) {
        items.sort((a, b) => a.name.localeCompare(b.name));
      }
      return items;
    },
    searchedItems() {
      return this.$store.state.Search.searchedItems;
    },
    displayedItems() {
      return this.showSearchResults ? this.searchedItems : this.items;
    }
  },
  created() {
    this.$store.dispatch("getItems");
  },
  methods: {
    searchItems(text) {
      if (text) {
        this.$store.dispatch("searchItems", text);
      } else {
        this.$store.commit("setAreSearchResultsShown", false);
      }
    }
  }
};
</script>
